import React, {memo} from 'react';
import {ResponsiveContainer, PieChart, Pie, Cell, Legend} from 'recharts';
import WidgetHeader from '../WidgetHeader';
import Button from '../Button';
import Icon from '../Icon';

function BooleanWidget({id, answers, question, options, unPin}) {

  const yes = answers.filter(answer => answer.value === true || answer.value === 'true').length;
  const no = answers.filter(answer => answer.value === false || answer.value === 'false').length;

  const data = [
    {name: `Yes (${(yes * 100 / answers.length).toLocaleString()}%)`, value: yes},
    {name: `No (${(no * 100 / answers.length).toLocaleString()}%)`, value: no}
  ];

  let children = [];
  let filteredOptions = options;
  if(question.pinned) {
    children.push(<Button id={`${id}_pin`} tertiary onClick={() => unPin(question)}><Icon name="go-pin" /></Button>)
    filteredOptions = options.filter(option => option.title !== "Pin");
  }
  
  return (
    <React.Fragment>
      <WidgetHeader
        id={id} 
        title={question.text} 
        options={filteredOptions} 
        children={children}
      />
      <ResponsiveContainer height="88%">
      <PieChart>
        <Pie data={data} dataKey="value" label>
          <Cell fill="#41BA56" />
          <Cell fill="#C3434A" />
        </Pie>
        <Legend verticalAlign="bottom" height={36} />
      </PieChart>
    </ResponsiveContainer>
    </React.Fragment>
  );
}

export default memo(BooleanWidget);
